import DamagePhotoModal from "./damage-photo-modal";

export default DamagePhotoModal;